(() => {
  'use strict';
  let controller;
  let interval;
  const storageKey = 'spiritual-hoochie-saved-rituals-v1';

  function boot() {
    controller?.abort();
    clearInterval(interval);
    interval = null;
    controller = new AbortController();
    const { signal } = controller;
    const $ = id => document.getElementById(`sh-${id}`);
    const on = (node, event, callback) => node?.addEventListener(event, callback, { signal });
    const configNode = $('sanctuary-data');
    if (!configNode) return;
    let config;
    try { config = JSON.parse(configNode.textContent); } catch { return; }
    const { questions, routes, moonData, ui } = config;
    const format = (key, values = {}) => Object.entries(values).reduce((s, [k, v]) => s.replaceAll(`{${k}}`, String(v)), ui[key]);
    let current = 0;
    const answers = Array(questions.length).fill(null);
    let route;
    let practice;
    let saved = [];
    try {
      const stored = JSON.parse(localStorage.getItem(storageKey) || '[]');
      if (Array.isArray(stored)) saved = stored.filter(s => s && typeof s.id === 'string' && typeof s.name === 'string' && typeof s.prompt === 'string' && Array.isArray(s.steps) && s.steps.every(t => typeof t === 'string')).slice(-12);
    } catch {}

    function renderQuestion() {
      if (!$('quiz-form')) return;
      $('question-text').textContent = questions[current].title;
      $('quiz-count').textContent = format('question_count', { current: current + 1, total: questions.length });
      $('quiz-progress').style.width = `${(current + 1) / questions.length * 100}%`;
      $('back-question').disabled = current === 0;
      $('next-question').textContent = current === questions.length - 1 ? ui.find : ui.next;
      $('next-question').disabled = answers[current] === null;
      $('quiz-options').replaceChildren();
      questions[current].options.forEach((text, index) => {
        const label = document.createElement('label');
        label.className = 'sh-quiz-option';
        const input = document.createElement('input');
        Object.assign(input, { type: 'radio', name: 'sh-answer', value: String(index), checked: answers[current] === index, required: true });
        on(input, 'change', () => { answers[current] = index; $('next-question').disabled = false; });
        const span = document.createElement('span'); span.textContent = text;
        label.append(input, span); $('quiz-options').append(label);
      });
    }

    function showResult() {
      const scores = routes.map(() => 0);
      answers.forEach(i => scores[i]++);
      const max = Math.max(...scores);
      const winner = [...answers].reverse().find(i => scores[i] === max);
      route = routes[winner];
      document.querySelectorAll('[data-sh-recommendation]').forEach(card => { card.hidden = card.dataset.shRecommendation !== route.id; });
      const d = new Date();
      const day = Math.floor(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()) / 86400000);
      practice = route.practices[day % route.practices.length];
      $('quiz-form').hidden = true; $('quiz-progress-row').hidden = true;
      document.querySelector('.sh-progress-track').hidden = true; $('quiz-result').hidden = false;
      $('result-title').textContent = route.title; $('result-description').textContent = route.description;
      $('result-prompt').textContent = practice.prompt; $('result-steps').replaceChildren();
      practice.steps.forEach(s => { const li = document.createElement('li'); li.textContent = s; $('result-steps').append(li); });
      $('save-status').textContent = ''; $('save-ritual').textContent = ui.save; $('result-title').focus({ preventScroll: true });
    }

    on($('quiz-form'), 'submit', e => {
      e.preventDefault(); if (answers[current] === null) return;
      if (current < questions.length - 1) { current++; renderQuestion(); $('question-text').focus({ preventScroll: true }); } else showResult();
    });
    on($('back-question'), 'click', () => { if (current) { current--; renderQuestion(); $('question-text').focus({ preventScroll: true }); } });
    on($('retake'), 'click', () => {
      current = 0; answers.fill(null); $('quiz-result').hidden = true; $('quiz-form').hidden = false;
      $('quiz-progress-row').hidden = false; document.querySelector('.sh-progress-track').hidden = false;
      renderQuestion(); $('question-text').focus({ preventScroll: true });
    });

    function persist() { try { localStorage.setItem(storageKey, JSON.stringify(saved)); return true; } catch { return false; } }
    function renderSaved() {
      const list = $('saved-list'); if (!list) return;
      list.replaceChildren();
      if (!saved.length) { const p = document.createElement('p'); p.textContent = ui.empty; list.append(p); }
      saved.forEach(s => {
        const item = document.createElement('article'); item.className = 'sh-saved-item';
        const heading = document.createElement('h3'); heading.textContent = s.name;
        const text = document.createElement('p'); text.textContent = s.steps.join(' ');
        const prompt = document.createElement('p'); prompt.textContent = s.prompt;
        const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'sh-text-button'; remove.textContent = ui.remove;
        on(remove, 'click', () => { saved = saved.filter(x => x.id !== s.id); persist(); renderSaved(); });
        item.append(heading, text, prompt, remove); list.append(item);
      });
      $('clear-saved').hidden = saved.length === 0;
    }
    on($('save-ritual'), 'click', () => {
      if (!route || !practice) return;
      const id = `${route.id}-${route.practices.indexOf(practice)}`;
      if (saved.some(s => s.id === id)) { $('save-status').textContent = ui.already_saved; return; }
      saved.push({ id, name: route.name, steps: practice.steps, prompt: practice.prompt }); saved = saved.slice(-12);
      const ok = persist(); renderSaved(); $('save-status').textContent = ok ? ui.saved_ok : ui.saved_temporary;
      $('save-ritual').textContent = ui.saved;
    });
    on($('clear-saved'), 'click', () => { saved = []; persist(); renderSaved(); });

    let messages = [];
    try { messages = JSON.parse($('message-data')?.textContent || '[]').filter(row => Array.isArray(row) && row.length === 3 && row.every(t => typeof t === 'string')); } catch {}
    let lastMessage = 0;
    if ($('pull-message')) $('pull-message').disabled = messages.length === 0;
    on($('pull-message'), 'click', () => {
      if (!messages.length) return;
      let next = messages.length === 1 ? 0 : Math.floor(Math.random() * (messages.length - 1));
      if (messages.length > 1 && next >= lastMessage) next++;
      lastMessage = next;
      const [label, text, prompt] = messages[next];
      $('message-label').textContent = label; $('message-text').textContent = text; $('message-prompt').textContent = prompt;
    });
    on(document, 'shopify:block:select', e => {
      const index = Number(e.target.dataset.shMessageIndex);
      if (!Number.isInteger(index) || !messages[index]) return;
      lastMessage = index;
      const [label, text, prompt] = messages[index];
      $('message-label').textContent = label; $('message-text').textContent = text; $('message-prompt').textContent = prompt;
    });

    function setMoon(phase) {
      if (!$('moon-panel')) return;
      const value = moonData[phase];
      ['new', 'full'].forEach(p => { $(`${p}-tab`).setAttribute('aria-selected', String(p === phase)); $(`${p}-tab`).tabIndex = p === phase ? 0 : -1; });
      $('moon-panel').setAttribute('aria-labelledby', `sh-${phase}-tab`);
      document.querySelectorAll('[data-sh-moon-schedule]').forEach(schedule => { schedule.hidden = schedule.dataset.shMoonSchedule !== phase; });
      $('moon-title').textContent = value.title; $('moon-description').textContent = value.description;
      $('moon-prompt').textContent = value.prompt; $('moon-art-label').textContent = value.label;
      $('moon-disc').classList.toggle('sh-full', phase === 'full'); $('moon-steps').replaceChildren();
      value.steps.forEach(s => { const li = document.createElement('li'); li.textContent = s; $('moon-steps').append(li); });
    }
    ['new', 'full'].forEach(phase => {
      on($(`${phase}-tab`), 'click', () => setMoon(phase));
      on($(`${phase}-tab`), 'keydown', e => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
        e.preventDefault(); const target = e.key === 'Home' ? 'new' : e.key === 'End' ? 'full' : phase === 'new' ? 'full' : 'new';
        setMoon(target); $(`${target}-tab`).focus();
      });
    });

    const dialogs = document.querySelectorAll('#sh-product-dialog, #sh-pause-dialog');
    document.querySelectorAll('.sh-open-product').forEach(button => on(button, 'click', () => $('product-dialog')?.showModal()));
    dialogs.forEach(dialog => {
      dialog.querySelectorAll('.sh-dialog-close, .sh-dialog-close-button').forEach(button => on(button, 'click', () => dialog.close()));
      on(dialog, 'click', e => {
        if (e.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) dialog.close();
      });
    });

    let remaining = 180, endTime = 0;
    function displayTime() {
      if (!$('timer-display')) return;
      $('timer-display').textContent = `${Math.floor(remaining / 60)}:${String(remaining % 60).padStart(2, '0')}`;
      $('timer-display').setAttribute('aria-label', format('timer_label', { minutes: Math.floor(remaining / 60), seconds: remaining % 60 }));
    }
    function stopTimer() { clearInterval(interval); interval = null; }
    function resetTimer() { stopTimer(); remaining = 180; displayTime(); $('timer-status').textContent = ui.timer_ready; $('timer-toggle').textContent = ui.timer_start; }
    on($('start-pause'), 'click', () => { resetTimer(); $('pause-dialog').showModal(); });
    on($('timer-toggle'), 'click', () => {
      if (interval !== null) {
        remaining = Math.max(0, Math.ceil((endTime - Date.now()) / 1000)); stopTimer(); displayTime();
        $('timer-toggle').textContent = ui.timer_continue; $('timer-status').textContent = ui.timer_paused; return;
      }
      if (!remaining) remaining = 180;
      endTime = Date.now() + remaining * 1000; $('timer-toggle').textContent = ui.timer_pause; $('timer-status').textContent = ui.timer_running;
      interval = setInterval(() => {
        remaining = Math.max(0, Math.ceil((endTime - Date.now()) / 1000)); displayTime();
        if (!remaining) { stopTimer(); $('timer-status').textContent = ui.timer_complete; $('timer-toggle').textContent = ui.timer_again; }
      }, 200);
    });
    on($('timer-reset'), 'click', resetTimer); on($('pause-dialog'), 'close', resetTimer);
    renderQuestion(); renderSaved();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', () => { controller?.abort(); clearInterval(interval); requestAnimationFrame(boot); });
})();


